import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {AuthService} from './auth.service';

@Injectable()

export class AuthGuard  {
  constructor( private authService: AuthService, private router: Router ) {}
  canActivate ( route: ActivatedRouteSnapshot, state: RouterStateSnapshot ): boolean {
    const url: string = state.url;
    return this.checkLogin(url);
  }
  checkLogin( url: string ): boolean {
      if (this.authService.isLoggedIn()) {
      return true;
    }
    this.authService.redirect = url;
    this.router.navigate(['login']);
    return false;
  }
}

